/**
 * 支付模块接口
 * @description 支付方式、收款方式、汇率、POS机等支付相关接口
 */

import axios from "@/utils/request";
import Api from "../api";
import * as Common from "../common.type";
import * as Request from "../request.type";
import * as ResponseData from "../response.type";

/**
 * 获取收款方式列表
 * @param organizationIds 组织ID数组
 * @returns 收款方式列表结果
 */
export const Http_getPaymentModeList = async (
  /** 组织ID数组 */
  organizationIds: number[]
) => {
  return await axios.post<ResponseData.PaymentModeItemData[]>(
    Api.DEPOSIT_TRANSACTION_MODE_LIST,
    {
      organizationIds,
    }
  );
};

/**
 * 获取POS机列表
 * @returns pos列表
 */
export const Http_getPosList = async () => {
  return await axios.get<ResponseData.PosTerminalItem[]>(Api.GET_POS_LIST);
};

/**
 * 获取报表结算门市存款单筛选收款方式
 * @returns 收款方式列表
 */
export const Http_getCollectingWayList = async () => {
  const res = await axios.get<ResponseData.CollectingWayItem[]>(
    Api.GET_REPORT_CollectingWayList
  );
  if (res.code === 0) {
    res.data.forEach((item) => {
      item.nameCn = item.name;
    });
  }
  return res;
};

/**
 * 支付回调
 */
export const Http_postPaymentCallback = async (
  params: Request.PaymentCallbackParams
) => {
  return await axios.post(Api.POST_PAYMENT_CALLBACK, params);
};

/**
 * 获取支付方式列表
 */
export const Http_getPayMentList = async () => {
  return await axios.get<ResponseData.PayMentItem[]>(Api.GET_PAYMENT_LIST);
};

/**
 * 获取交易方式列表（支付选项列表）
 * @returns 交易方式列表结果
 */
export const Http_getPaymentOptionList = async () => {
  return await axios.post<ResponseData.PaymentOptionItem[]>(
    Api.GET_STORE_TRANSACTION_MODE_LIST,
    {}
  );
};

/**
 * 获取汇率列表
 * @param date 日期 YYYY-MM-DD
 * @returns 汇率列表结果
 */
export const Http_getExchangeRateList = async (date: string) => {
  return await axios.get<ResponseData.ExchangeRateItem[]>(
    Api.GET_EXCHANGE_RATE_LIST,
    {
      params: { date },
    }
  );
};

/**
 * POS操作日志列表查询
 * @param params 查询参数
 * @returns POS操作日志列表
 */
export const Http_getPosOperateLogList = async (
  params: Request.GetPosOperateLogListParams
) => {
  return await axios.post<
    Common.PaginationResponse<ResponseData.PosOperateLogItem[]>
  >(Api.GET_OPERATE_LOG_LIST, params);
};

/**
 * 创建支付
 * @param params 创建支付参数
 * @returns 创建支付结果
 */
export const Http_postCreatePayment = async (
  params: Request.CreatePaymentParams
) => {
  return await axios.post<ResponseData.CreatePaymentData>(
    Api.POST_CREATE_PAY,
    params,
    {
      headers: {
        closeDefaultMessage: true, // 不使用默认提示
      },
    }
  );
};

/**
 * 获取交易记录汇总
 */
export const Http_postTransactionRecordSummary = async (params: any) => {
  return await axios.post<
    {
      amount: string;
      currencyType: number;
    }[]
  >(Api.POST_TRADE_RECORD_SUMMARY, params);
};
